import { Asset, CapabilityModelUiDefinition } from '@api';
import { ICapabilityModelDefinition } from 'src/app/shared/interfaces/capability-model-definition';

export class AssetSelectedStateModel {
    public selectedAssetId: string;
    public selectedEdgeDeviceId: string;
    public asset: Asset;
    public capabilityModelDefinition: ICapabilityModelDefinition;
    public capabilityModelUi: CapabilityModelUiDefinition;
    public assetNotFound: boolean;
    public assetNotConnected: boolean;
}

export const assetSelectedDefaults = {
    name: 'assetSelected',
    defaults: {
        selectedAssetId: null as string,
        selectedEdgeDeviceId: null as string,
        asset: null as Asset,
        capabilityModelDefinition: null as ICapabilityModelDefinition,
        capabilityModelUi: null as CapabilityModelUiDefinition,
        assetNotFound: false,
        assetNotConnected: false,
    },
};
